import config from '../../config/config.json';

export const SITE_NAME_UPPER = config.siteName.toUpperCase();
export const SITE_NAME_LOWER = config.siteName.toLowerCase();
export const SITE_NAME_CAPITALIZED = config.siteName.charAt(0).toUpperCase() + config.siteName.slice(1).toLowerCase();

export const SITE_LOGO = config.logo;
export const SITE_LOGO_ALT = `Logo ${config.siteName}`;